import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
window.PROPS = {
  defaultReturnUrl: process.env.REACT_APP_ADMIN,
  defaultClientId: "824cd7bf40af4a2892e11d781533208f",
  serverPath: process.env.REACT_APP_API_BASE_URL,
  imagePath: "/gwork/passport/static/img",
  cookieDomain: ".beijing.gov.cn",
  path: {
    verifyMobileLegal: "/verify/mobile/legal",
    sendVercode: "/login/send/verCode",
    verifyVerCode: "/login/by/verCode",
    exchangeOpenCode: "/login/exchange/openCode",
    generalGetQrCode: "/general/get/qrcode",
    generalListenQrStatus: "/general/polling/qrcode",
  },

  privacyProtocolChineseUrl: `https://me.jdcloud.com/protocol/gwork/privacy/chinese/`,
  privacyProtocolEnglishUrl: `https://me.jdcloud.com/protocol/gwork/privacy/chinese/`,
  serviceProtocolChineseUrl: `https://me.jdcloud.com/protocol/gwork/service/chinese/`,
  serviceProtocolEnglishUrl: `https://me.jdcloud.com/protocol/gwork/service/chinese/`,
};

ReactDOM.render(<App></App>, document.getElementById("root"));
